import React from 'react';
import {NavLink} from 'react-router-dom';

import ConditionalWrapper from 'components/ConditionalWrapper';

import {SupportSwitchLinkProps} from '../types';

interface SupportSwitchButtonInterface {
    supportSwitchLink?: SupportSwitchLinkProps;
    closeDrawer?: () => void;
};

const SupportSwitchButton: React.FC<SupportSwitchButtonInterface> = ({supportSwitchLink, closeDrawer}) => {
    const handleLinkClick = (action?: () => void) => {
        closeDrawer && closeDrawer();
        action && action();
    };

    return (
        <ConditionalWrapper
            condition={!!supportSwitchLink?.url}
            wrapper={children => <NavLink to={supportSwitchLink?.url as string}>{children}</NavLink>}
        >
            <div
                className='role-switch'
                onClick={() => handleLinkClick(supportSwitchLink?.action)}
            >
                <i className='fal fa-question-circle with-accent' />
            </div>
        </ConditionalWrapper>
    );
};

export default SupportSwitchButton;